import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { DisplayText } from '../../../display-text';
const b = bemClassBuilder('v-checkbox-input');
export const CheckboxInput = observer(props => {
    const { value: checked, onChange, onChangeValue, style, disabled, className, children } = props;
    const [isFocused, setIsFocused] = useState(false);
    const handleChange = event => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(event.target.checked);
    };
    return (_jsx("div", { className: b.block({ style: style, disabled }, className), children: _jsxs("label", { className: b.element('label', { disabled }), children: [_jsx("input", { id: props.id, className: b.element('input'), type: "checkbox", value: props.optionValue, name: props.name, disabled: disabled, checked: checked, onChange: handleChange, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false) }), _jsx("div", { className: b.element('button', { focused: isFocused, checked }) }), _jsx(DisplayText, { label: props.label }), children] }) }));
});
CheckboxInput.displayName = 'CheckboxInput';
//# sourceMappingURL=checkbox-input.js.map